import React from 'react'
import { OmButton } from '@owma/kit'
import { useStore } from 'react-redux'

import classNames from 'classnames'
import settings from 'popups/Settings'
import Logo from 'components/cleanui/layout/TopBar/Logo'

import toolbarHelp24 from 'assets/images/toolbar-help-24.svg'
import toolbarSettings24 from 'assets/images/toolbar-settings-24.svg'

import UserMenu from './UserMenu'
import styles from './style.module.scss'

const TopBar: React.FC = () => {
  const store = useStore()
  const { appsettings } = store.getState() as any

  const { logo, isOfficenextMessenger, isDesktopSession } = appsettings

  const helpElem =
    isOfficenextMessenger === true || isDesktopSession === true ? null : (
      <a href="https://officemail.gitbook.io/web/" target="_blank" rel="noopener noreferrer">
        <div className={classNames(styles.helpWrapper)}>
          <img src={toolbarHelp24} alt="help" />
        </div>
      </a>
    )

  return (
    <div className={classNames(styles.topbar, 'topbar')}>
      {isDesktopSession === true ? null : (
        <div className={styles.logoContainer}>
          <Logo noWrapper className={styles.logoImg} alt={logo} />
        </div>
      )}
      <div className="mr-auto" id="search-container" />
      <div className="mr-4" id="portalMenu0" />
      {helpElem}
      {isDesktopSession === true ? null : (
        <div className={classNames(styles.settingsWrapper)}>
          <OmButton
            variant="text"
            icon={<img src={toolbarSettings24} alt="settings" />}
            onClick={() => {
              settings.open({})
            }}
          />
        </div>
      )}
      {isDesktopSession === true ? null : (
        <div className="last">
          <React.Suspense fallback={<div>Loading...</div>}>
            <UserMenu />
          </React.Suspense>
        </div>
      )}
    </div>
  )
}

export default TopBar
